module.exports = __webpack_public_path__ + "images/interview-HP-2.svg";